export default class {

    constructor() {
        this.trigger();
        this.dropDown();
        this.outside();
    }

    trigger() {
        $('[data-navigation-trigger]').on('click', function(event) {
            event.preventDefault();
            const parent = $('.mainNavigation');
            parent.toggleClass('opened');
            if ( ! parent.hasClass('opened')) {
                parent.find('.has-dropdown').removeClass('hover');
            }
        });
    }

    dropDown() {
        $('.mainNavigation li.has-dropdown > a').on('click', function(event) {
            event.preventDefault();
            $(this).parent('li')
                .toggleClass('hover')
                .siblings('li.has-dropdown')
                .removeClass('hover');
        });
    }

    outside() {
        $(document).on('click', function(event) {
            const container = $('.mainNavigation li.has-dropdown');
            if (container.has(event.target).length === 0) {
                container.removeClass('hover');
            }
        });
    }
}


// WEBPACK FOOTER //
// ./resources/js/src/core/Navigation.js